function toggleBurgerMenu(burger) {
    const menu = document.querySelector('.burger-menu');
    const isOpen = burger.classList.toggle('open');
    
    menu.classList.toggle('active', isOpen);
  
    // Блокируем прокрутку страницы при открытом меню
    document.body.style.overflow = isOpen ? 'hidden' : '';
  }